import CartLabelSingleton from './cart-label';

/**
 * Cart Label Initialization
 * Sets up event listeners for cart label refresh triggers
 * Global functions are now handled by cart-label-global.js
 */

// Listen for cart:updated event (main cart update event)
document.addEventListener('cart:updated', () => {
  // Refresh labels when cart is updated from external sources
  // eslint-disable-next-line no-console
  console.log(
    'Cart label init: Detected cart:updated event, refreshing labels',
  );
  CartLabelSingleton.refresh('cart_update').catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Error refreshing cart labels on cart update:', error);
  });
});

// Listen for cart:add event (when items are added to cart)
document.addEventListener('cart:add', () => {
  // Wait a short delay to ensure the cart is updated first
  setTimeout(() => {
    // eslint-disable-next-line no-console
    console.log('Cart label init: Detected cart:add event, refreshing labels');
    CartLabelSingleton.refresh('cart_add').catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error refreshing cart labels after item add:', error);
    });
  }, 500);
});

// Listen for cart:refresh event (custom event for explicit refresh requests)
document.addEventListener('cart:refresh', () => {
  // eslint-disable-next-line no-console
  console.log(
    'Cart label init: Detected cart:refresh event, refreshing labels',
  );
  CartLabelSingleton.refresh('cart_refresh').catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Error refreshing cart labels on explicit refresh:', error);
  });
});

// Listen for openMiniCart event (when mini cart is opened)
document.addEventListener('openMiniCart', () => {
  // This is already handled in cart.js, but adding here as a fallback
  // in case the mini cart is opened through other means
  // eslint-disable-next-line no-console
  console.log(
    'Cart label init: Detected openMiniCart event, refreshing labels',
  );
  CartLabelSingleton.refresh('minicart').catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Error refreshing cart labels on mini cart open:', error);
  });
});

// Initialize on page load
window.addEventListener('DOMContentLoaded', () => {
  // Check if we're on a cart-related page and refresh if needed
  const isCartPage = window.location.pathname.includes('/cart');
  if (isCartPage) {
    // eslint-disable-next-line no-console
    console.log('Cart label init: Cart page detected, refreshing labels');
    CartLabelSingleton.refresh('cartpage').catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error refreshing cart labels on cart page load:', error);
    });
  }
});

// Export for module use
export default CartLabelSingleton;
